import { Dispatch } from 'redux';

import { Events } from '../constants/webSocketConsts/events';
import { Price, productsApi } from '../services/api/productsApi';

import { updateListCache } from './updateListCache';

export function handlePriceUpdate(
  event: Events,
  items: Price[],
  dispatch: Dispatch<any>,
) {
  // for price showing on price detail
  const priceObj = items.at(0);
  if (!priceObj) {
    console.warn('price not found');
    return;
  }
  // for prices on price detail page
  dispatch(
    productsApi.util.updateQueryData(
      'getPricesByProductId',
      priceObj.productId,
      (draft?: Price[]) => {
        updateListCache(event, items, draft);
      },
    ),
  );
  // for prices on portal price list page
  dispatch(
    productsApi.util.updateQueryData(
      'getPricesByPortal',
      undefined,
      (draft?: Price[]) => {
        updateListCache(event, items, draft);
      },
    ),
  );
}
